export function convertPrice(price) {
  return price.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
}

// İki bağımsız eksen: yön (kind) ve işlem (listingType). Renk yönü taşır
// (yeşil/mavi = veren teklif, turuncu = alıcı talebi), etiket ise işlem
// türünü. Talep tarafında "Aranıyor" fiili rozetin bir teklif değil arayış
// olduğunu klasik ilan diliyle netleştirir ("Kiralık · Alınan" çelişik okunuyordu).
export function advertBadge(advert) {
  const isSeller = advert.kind === "seller";
  const isRent = advert.listingType === "rent";
  if (isSeller) {
    return isRent
      ? { label: "Kiralık", background: "#2D8CF0" }
      : { label: "Satılık", background: "#1EC28B" };
  }
  return {
    label: isRent ? "Kiralık Aranıyor" : "Satılık Aranıyor",
    background: "#F08A3E",
  };
}

// Kiralıkta price/priceMin/priceMax aylık kira -> "TL/ay" eki.
export function advertPriceText(advert) {
  const isSeller = advert.kind === "seller";
  const suffix = advert.listingType === "rent" ? " TL/ay" : " TL";
  if (isSeller) {
    return `${convertPrice(advert.price)}${suffix}`;
  }
  return `${convertPrice(advert.priceMin)} - ${convertPrice(
    advert.priceMax
  )}${suffix}`;
}
